module.exports = __webpack_public_path__ + "img/cover_guillermo_1200x1600.98dd8b15.jpg";